const formateDate = ({ date = "" }) => {
    if (date) {
        const getDate = date.split("T")[0].split("-").reverse().join("/");
        return getDate;
    }
    return null;
}

export { formateDate }